import React from "react";
import { DatePicker as FormikPicker } from "formik-mui-lab";

export default function DatePicker(props) {
  return (
    <FormikPicker
      textField={{ margin: props.margin ?? "normal", fullWidth: true }}
      inputFormat="dd/MM/yyyy"
      {...props}
    />
  );
}
